/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * point-service.ts  2026-08-26T09:15:21+08:00
 */
import type { R, RpcService, MethodConfig as M, PagedList } from 'krpc-base'

import type { PointLogListSlidePage, PointLogCard } from './wy-dto'

const _ = 'Point/'

export class PointService {
  constructor(readonly r: RpcService) {}
  // 查询用户积分明细
  listPointLog(d: PointLogListSlidePage, m?: M): R<PagedList<PointLogCard>> {
    return this.r.async(_ + 'listPointLog', d, m)
  }
}
